import React from 'react';
import classnames from 'classnames';
import { useMMDispatchActions } from '../../_hocs/withOwnReduxStore';
import { initGallectionStream, initGallectionDeviationStream, initTierStream, } from '../../actions';
import { useTranslation } from 'react-i18next';
import { useCurrentGallection } from '../../_hocs/withCurrentGallection';
import { useCurrentSubfolder } from '../../_hocs/withCurrentSubfolder';
import { useSearch } from '../../_hocs/withSearch';
import { useCurrentMediaSource } from '../../_hocs/withCurrentMediaSource';
import { MediaSourceType } from '../../types';
import { useCurrentTier } from '../../_hocs/withCurrentTier';
import breadcrumbStyles from './Breadcrumbs.scss';
export var Breadcrumbs = function () {
    var t = useTranslation().t;
    var currentMediaSource = useCurrentMediaSource().currentMediaSource;
    var _a = useCurrentGallection(), currentGallection = _a.currentGallection, unsetCurrentFolderId = _a.unsetCurrentFolderId;
    var _b = useCurrentSubfolder(), currentSubfolder = _b.currentSubfolder, unsetCurrentSubfolderId = _b.unsetCurrentSubfolderId;
    var _c = useCurrentTier(), currentTier = _c.currentTier, unsetCurrentTierId = _c.unsetCurrentTierId;
    var _d = useSearch(), searchQuery = _d.searchQuery, unsetSearchInput = _d.unsetSearchInput, unsetSearchQuery = _d.unsetSearchQuery;
    var actions = useMMDispatchActions({
        initGallectionStream: initGallectionStream,
        initGallectionDeviationStream: initGallectionDeviationStream,
        initTierStream: initTierStream,
    });
    if (currentMediaSource === MediaSourceType.CUSTOM_SET) {
        return null;
    }
    var crumbs = [];
    if (currentMediaSource === MediaSourceType.BROWSE) {
        crumbs.push({
            node: t(searchQuery ? 'mediapopup.search.searchResults' : 'mediapopup.browse'),
        });
    }
    else {
        var allKey = void 0;
        switch (currentMediaSource) {
            case MediaSourceType.GALLERY:
                allKey = 'mediapopup.myGalleries';
                break;
            case MediaSourceType.COLLECTION:
                allKey = 'mediapopup.myCollections';
                break;
            case MediaSourceType.STATUS:
                allKey = 'mediapopup.myStatuses';
                break;
            case MediaSourceType.JOURNAL:
                allKey = 'mediapopup.myJournals';
                break;
            case MediaSourceType.POLL:
                allKey = 'mediapopup.myPolls';
                break;
            case MediaSourceType.POSTS:
                allKey = 'mediapopup.myPosts';
                break;
            case MediaSourceType.TIER:
                allKey = 'mediapopup.tiers';
                break;
            case MediaSourceType.TIER_DEVIATIONS:
            case MediaSourceType.TIER_POSTS:
                allKey = 'mediapopup.allTiers';
                break;
            default:
                allKey = 'mediapopup.allFolders';
                break;
        }
        crumbs.push({
            node: t(allKey),
            onClick: function () {
                unsetCurrentFolderId();
                unsetCurrentSubfolderId();
                unsetSearchInput();
                unsetSearchQuery();
                unsetCurrentTierId();
                if (currentMediaSource &&
                    [
                        MediaSourceType.GALLERY,
                        MediaSourceType.COLLECTION,
                        MediaSourceType.STASH,
                    ].includes(currentMediaSource)) {
                    actions.initGallectionStream({});
                }
                else if (currentMediaSource &&
                    [
                        MediaSourceType.TIER_DEVIATIONS,
                        MediaSourceType.TIER_POSTS,
                    ].includes(currentMediaSource)) {
                    actions.initTierStream();
                }
            },
        });
        if (currentGallection) {
            crumbs.push({
                node: currentGallection.name,
                onClick: function () {
                    unsetCurrentSubfolderId();
                    actions.initGallectionDeviationStream();
                },
            });
        }
        if (searchQuery) {
            crumbs.push({
                node: searchQuery,
            });
        }
        if (currentSubfolder) {
            crumbs.push({
                node: currentSubfolder.name,
            });
        }
        if (currentTier) {
            crumbs.push({
                node: currentTier.title,
            });
        }
    }
    return (React.createElement("div", { className: breadcrumbStyles['root'] }, crumbs.map(function (crumb, index) { return (React.createElement("span", { key: index, className: classnames(breadcrumbStyles['crumb'], index === crumbs.length - 1 && breadcrumbStyles['active']), onClick: crumb.onClick }, crumb.node)); })));
};
Breadcrumbs.displayName = 'Breadcrumbs';
export default Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.connected.js.map